import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/garantizar-conformidad-laboratorios")({
  head: () => buildRouteHead("/es/garantizar-conformidad-laboratorios", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/lab-services", replace: true });
  },
});
